//公共数据相关接口
import request from '@/utils/request'

//登录
export const getShipperAuth = (params = {}) => {
    return request({
        url: '/api/shipper/getShipperAuth',
        method: 'get',
        params
    })
}

/**
 * 获取全局配置
 **/
export const getGlobalConfig = (params = {}) => {
    return request({
        url: '/api/common/getConfig',
        method: 'get',
        params
    })
}

/**
 * 查看轨迹
 **/
export const carPosition = (params = {}) => {
    return request({
        url: '/api/shipper/carPosition',
        method: 'get',
        params
    })
}


/**
 * 验证卡号
 **/
export const validateAndCacheCardInfo = (card) => {
    return request({
        url: `https://ccdcapi.alipay.com/validateAndCacheCardInfo.json?_input_charset=utf-8&cardNo=${card}&cardBinCheck=true`,
        method: 'get',
    })
}

export function positionConversion(params = {}) {
    return request({
        url: "https://api.zhgylgl.com/api/shipper/positionConversion",
        method: 'get',
        params
    })
}